module.exports = __webpack_public_path__ + "static/img/manual-10.1515d6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-10.png
// module id = TEn4
// module chunks = 4